import { ITicketsAuto } from '../../../interfaces';
import privateHttpClient from '../privateHttpClient';
import TicketMapper from '../mappers/TicketMapper';
import { urlHttpGov } from '../../urls';
import { ITicketDistribution } from './TicketsService';

interface IListTicketsByGiveawayIdAndAppUserId {
    records: Array<ITicketsAuto>;
    count?: number;
}

class TicketsAutoService {
    private baseURL: string = `${urlHttpGov}/panel/ticket-auto`;

    async listTicketsByGiveawayId(raffleId: number, page: number, signal: AbortSignal): Promise<IListTicketsByGiveawayIdAndAppUserId> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/raffle/${raffleId}?page=${page}`, { signal });

        const domainData = {
            ...data,
            records: data.records.map((ticket: any) => TicketMapper.toDomain(ticket)),
        }

        return domainData;
    }

    async listTicketsByGiveawayIdAndAppUserId(giveawayId: number, appUserId: number, signal: AbortSignal): Promise<Array<ITicketsAuto>> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/raffle/${giveawayId}/app_user/${appUserId}`, { signal });

        return data.map((ticket: any) => TicketMapper.toDomain(ticket));
    }

    async getTicketDistributionByRaffle({giveawayAutoId, signal}: {giveawayAutoId: number, signal: AbortSignal}): Promise<ITicketDistribution[]> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/raffle/${giveawayAutoId}/ticket_distribution`, { signal });

        return data;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new TicketsAutoService();
